module.exports = __webpack_public_path__ + "static/board-06-3db35a00735137c5fb957c2f0e6aeded.jpg";